import type { ReactNode } from "react";
import { FlexibleInlineText } from "~/components/templates/common/purchase-modal/purchase-premium-appeal-banner/flexible-inline-text";
import { EXTERNAL_PATHS } from "~/const/paths";
import { sendTrackingSelectOrViewPromotion } from "~/lib/tracking/events";
import { goToWelcomePage } from "~/util/go-to-welcome-page";
import { uriConverter } from "~/util/uri-converter";

const TOP_SUB_TEXT = "＼DMMプレミアムなら／";
const BOTTOM_SUB_TEXT_FOR_POINT = <FlexibleInlineText texts={["さらに無料登録後すぐに", "550ptをプレゼント！"]} />;
const BOTTOM_SUB_TEXT_FOR_ANIME = "アニメ・エンタメ17万本以上配信中！";
const MAIN_TEXT_FOR_DMM_PREMIUM = "DMMプレミアム会員なら";
const MAIN_TEXT_FOR_UNLIMITED_VIEWING = "この作品含む対象作品が見放題！";
const MAIN_TEXT_FOR_PURCHASE = "この作品をお得に購入できる！";
const MAIN_TEXT_FOR_POINT = "登録後すぐ使えるポイントで";
const MAIN_TEXT_FOR_BENEFITS = "550円分お得に購入！";
const BUTTON_TEXT_FOR_FREE_TRIAL = "30日間無料トライアル";
const BUTTON_TEXT_FOR_DMM_PREMIUM = "DMMプレミアム入会";
const BUTTON_TEXT_FOR_BENEFITS = "登録特典を利用して購入";

type BannerTexts = {
  firstLineMainText: string;
  secondLineMainText: string;
  buttonText: string;
  topSubText?: string;
  bottomSubText?: ReactNode;
  onClickBanner: () => void;
  onMountBanner?: () => void;
};

type Args = {
  isLimitedPremium: boolean;
  isDualSalesModel: boolean;
  isPremiumMemberBefore: boolean;
  currentHref: string;
};

export const selectBannerParams = (args: Args): BannerTexts | undefined => {
  const { isLimitedPremium, isDualSalesModel, isPremiumMemberBefore, currentHref } = args;
  const backUrl = uriConverter.encode(currentHref);
  const premiumRegistrationPageUrl = `${EXTERNAL_PATHS.REGISTRATION}${backUrl}`;

  if (isDualSalesModel) {
    return getTextsForDualSalesModel(isPremiumMemberBefore);
  }
  if (isLimitedPremium) {
    return getTextsForLimitedPremium(isPremiumMemberBefore);
  }
  if (!isPremiumMemberBefore) {
    return {
      firstLineMainText: MAIN_TEXT_FOR_POINT,
      secondLineMainText: MAIN_TEXT_FOR_BENEFITS,
      topSubText: TOP_SUB_TEXT,
      buttonText: BUTTON_TEXT_FOR_BENEFITS,
      onClickBanner: () => {
        sendTrackingSelectOrViewPromotion({
          creativeName: "banner",
          promotionId: "join_group_premium_intent",
          promotionName: "DMMプレミアム・30日間無料トライアル",
          locationId: "purchase_modal",
        });
        location.href = premiumRegistrationPageUrl;
      },
      onMountBanner: () => {
        sendTrackingSelectOrViewPromotion({
          creativeName: "banner",
          promotionId: "join_group_premium_intent",
          promotionName: "DMMプレミアム・30日間無料トライアル",
          locationId: "purchase_modal",
          isView: true,
        });
      },
    };
  }
  return;
};

const getTextsForDualSalesModel = (isPremiumMemberBefore: boolean): BannerTexts => {
  const commonTexts = {
    firstLineMainText: MAIN_TEXT_FOR_DMM_PREMIUM,
    secondLineMainText: MAIN_TEXT_FOR_UNLIMITED_VIEWING,
    onClickBanner: () => goToWelcomePage(),
  };
  return isPremiumMemberBefore
    ? {
        ...commonTexts,
        bottomSubText: BOTTOM_SUB_TEXT_FOR_ANIME,
        buttonText: BUTTON_TEXT_FOR_DMM_PREMIUM,
      }
    : {
        ...commonTexts,
        bottomSubText: BOTTOM_SUB_TEXT_FOR_POINT,
        buttonText: BUTTON_TEXT_FOR_FREE_TRIAL,
      };
};

const getTextsForLimitedPremium = (isPremiumMemberBefore: boolean): BannerTexts => {
  const commonTexts = {
    firstLineMainText: MAIN_TEXT_FOR_DMM_PREMIUM,
    secondLineMainText: MAIN_TEXT_FOR_PURCHASE,
    onClickBanner: () => goToWelcomePage(),
  };
  return isPremiumMemberBefore
    ? {
        ...commonTexts,
        bottomSubText: BOTTOM_SUB_TEXT_FOR_ANIME,
        buttonText: BUTTON_TEXT_FOR_DMM_PREMIUM,
      }
    : {
        ...commonTexts,
        bottomSubText: BOTTOM_SUB_TEXT_FOR_POINT,
        buttonText: BUTTON_TEXT_FOR_FREE_TRIAL,
      };
};
